// src/lib/mutations.ts
import { type QueryKey, useMutation, useQueryClient } from "@tanstack/react-query";

import { errorMessage } from "@/api/errors";
import { useToast } from "@/design-system";

type Opts = { invalidate?: QueryKey[]; success?: string; silentError?: boolean };

/** طفرة موحّدة: تُبطل الكاش المتأثر، وتُظهر تنبيه نجاح/خطأ عربياً (أو تتركه للنموذج عند silentError). */
export function useAction<V, D>(fn: (v: V) => Promise<D>, opts: Opts = {}) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: fn,
    onSuccess: async () => {
      await Promise.all((opts.invalidate ?? []).map((queryKey) => qc.invalidateQueries({ queryKey })));
      if (opts.success) toast.push(opts.success, "ok");
    },
    onError: (e) => {
      if (!opts.silentError) toast.push(errorMessage(e), "bad");
    },
  });
}
